import React from 'react';

import styled from 'styled-components';

import NumberRating from 'uiToolkit/NumberRating';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NumberRatingPreview = ({ question }) => (
  <Wrapper>
    <NumberRating data={question.answerOptions} selectedId={-1} descriptionKey="score" />
  </Wrapper>
);

export default NumberRatingPreview;
